(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["us-redirect-popup"] && !Shopify.designMode) return;
  try {
    (function(){
  var modal = null;
  var dialog = null;

  function showPopup(){
    if (!modal) return;
    modal.style.display = 'flex';
    modal.setAttribute('aria-hidden', 'false');
  }

  window.closeRedirectInfo = function(){
    if (!modal) return;
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
  };

  function cleanUrl(){
    var url = new URL(window.location);
    url.searchParams.delete('redirected_from');
    window.history.replaceState({}, '', url);
  }

  function handleOutsideClick(event){
    if (!dialog || !modal) return;

    if (event.target === modal) {
      closeRedirectInfo();
    }
  }

  function handleEscape(event){
    if (event.key === 'Escape') {
      closeRedirectInfo();
    }
  }

  function init(){
    modal = document.getElementById('redirect-info');
    if (!modal) return;

    dialog = modal.querySelector('.redirect-info-box');

    modal.addEventListener('click', handleOutsideClick);
    document.addEventListener('keydown', handleEscape);

    var url = new URL(window.location);
    if(url.searchParams.get('redirected_from') === 'int'){
      showPopup();
      cleanUrl();
    }
  }

  document.addEventListener('DOMContentLoaded', init);
})();
  } catch(e) { console.error(e); }
})();

})();
